import { defineFakeRoute } from 'vite-plugin-fake-server/client'

/**
 * 表格数据接口（支持分页与排序）
 * - 路径：/mock/table/list
 * - 方法：GET
 * - 查询参数：page、pageSize、prop、order
 */
export default defineFakeRoute([
  {
    url: '/mock/table/list',
    method: 'get',
    /**
     * 返回分页列表数据
     * - page：当前页（默认 1）
     * - pageSize：每页数量（默认 20）
     * - prop：排序字段（可选）
     * - order：排序方向 asc | desc（可选）
     */
    response: ({ query }) => {
      const page = Number(query.page ?? 1)
      const pageSize = Number(query.pageSize ?? 20)
      const prop = String(query.prop ?? '')
      const order = String(query.order ?? '')

      // 示例数据（可替换为真实数据源）
      const source = [
        { xm: '林治宏', szyx: '土木工程系', xl: '专科生毕业', zy: '建筑工程技术', jtdz: '四川省南充市顺庆区白土坝佳兆业君汇上品', student_key: '05d884c91e3cef6d3fb6ab356368bf42' },
        { xm: '谢稼骏', szyx: '工程管理系', xl: '专科生毕业', zy: '工程造价', jtdz: '四川省遂宁市船山区油房街148号', student_key: '22d41c2ccc4e8fc78e04b115c51bbda9' },
        { xm: '关棋峰', szyx: '工程管理系', xl: '专科生毕业', zy: '工程造价', jtdz: '四川省自贡市自流井区', student_key: '90c5c9fa70510d2cc5b196db077b8eff' },
        { xm: '杨腾', szyx: '工程管理系', xl: '专科生毕业', zy: '工程造价', jtdz: '四川省广安市岳池县石桥接文星综合楼1-2-701', student_key: '416dd32a069ad76e063b31cedcb8e843' },
        { xm: '陈竹', szyx: '土木工程系', xl: '专科生毕业', zy: '水利水电工程技术', jtdz: '四川省资阳市乐至县翰林国际8栋2005', student_key: 'c0ff96463f433146a00059e0c71d2fc2' },
        { xm: '万书宏', szyx: '工程管理系', xl: '专科生毕业', zy: '建设工程管理', jtdz: '四川省乐山市市中区邦泰国际社区', student_key: 'e83c3b71e0af9a9053679deb640e725a' },
        { xm: '蒲楠', szyx: '工程管理系', xl: '专科生毕业', zy: '工程造价', jtdz: '四川省广元市利州区东坝文昌世家', student_key: '6d42e570a8ae707796ee1615453e3561' },
        { xm: '杨江炜', szyx: '工程管理系', xl: '专科生毕业', zy: '工程造价', jtdz: '四川省雅安市天全县新场乡董家村二组32号', student_key: 'b070bd93521acf960d0ec0516b3ae515' },
        { xm: '罗海龙', szyx: '机电与信息工程系', xl: '专科生毕业', zy: '电气自动化技术', jtdz: '四川省南充市嘉陵区茶盘路二段', student_key: 'bd3c976430f9cb5922c2280aa572d148' },
        { xm: '付顺义', szyx: '工程管理系', xl: '专科生毕业', zy: '工程造价', jtdz: '四川省阿坝州茂县沟口镇长安村', student_key: 'b4fc8f0f3cd9787f05d8253c6e5a2d1b' },
        { xm: '徐毅', szyx: '材料工程系', xl: '专科生毕业', zy: '建筑材料工程技术', jtdz: '四川省成都市双流区永安镇', student_key: '1239ed0b4b98f620538543d3b332b72f' },
        { xm: '吕柯翔', szyx: '工程管理系', xl: '专科生毕业', zy: '工程造价', jtdz: '四川省什邡市雍城东路386号一栋二单元601号', student_key: '212340fc7f221177e5a6fc9cf9bcf5bf' },
        { xm: '杨宇', szyx: '土木工程系', xl: '专科生毕业', zy: '建筑工程技术', jtdz: '四川省南充市嘉陵区陈寿路42号', student_key: 'a1e27f5f2182d28f9eee067b616a1636' },
        { xm: '王澜渊', szyx: '土木工程系', xl: '专科生毕业', zy: '建筑工程技术', jtdz: '四川省眉山市仁寿县泉水街40号', student_key: 'e13787585b15cb456bda04501878baa5' },
        { xm: '张舰', szyx: '土木工程系', xl: '专科生毕业', zy: '建筑工程技术', jtdz: '四川省乐山市五通桥区竹根镇茶花村6组36号', student_key: '1a6f65a0f6a1856ebb701dbd1be02e0a' },
      ]

      // 排序
      const sorted = [...source]
      if (prop && (order === 'asc' || order === 'desc')) {
        sorted.sort((a: any, b: any) => {
          const av = a[prop]
          const bv = b[prop]
          if (av === bv) {
            return 0
          }
          const comp = av > bv ? 1 : -1
          return order === 'asc' ? comp : -1 * comp
        })
      }

      // 分页
      const total = sorted.length
      const start = (page - 1) * pageSize
      const end = start + pageSize
      const list = sorted.slice(start, end)

      return {
        error: '',
        status: 1,
        data: {
          page,
          pageSize,
          total,
          list,
        },
      }
    },
  },
])
